module.exports = __webpack_public_path__ + "fonts/iconfont.8f11ec47.woff";